import { POPUP_ALERT } from "../constants/ActionTypes"

/**
 *
 * @type {{POPUP_STATE: 0:off 1: on, POPUP_MODULE: 'module_name'}}
 */
const initialPopupState = {
    POPUP_STATE: 0,
    POPUP_MODULE: null,
    POPUP_PARAMETERS: null,
    POPUP_CALLBACK_KEY: null,
    POPUP_CALLBACK_VALUE: null
}

export default function ( state = initialPopupState, action = {} ){
    let POPUP_STATE = action.POPUP_STATE;
    let POPUP_MODULE = action.POPUP_MODULE;
    let POPUP_PARAMETERS = action.POPUP_PARAMETERS;
    let POPUP_CALLBACK_KEY = action.POPUP_CALLBACK_KEY;
    let POPUP_CALLBACK_VALUE = action.POPUP_CALLBACK_VALUE;
    switch( action.type ){
        case POPUP_ALERT.POPUP_STATE:
            return Object.assign({},state,{
                POPUP_STATE,
                POPUP_MODULE,
                POPUP_PARAMETERS,
                POPUP_CALLBACK_KEY,
                POPUP_CALLBACK_VALUE
            });
        break;
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./common/reducers/popup_alert.js